// extracted by mini-css-extract-plugin
export default {"Drumpad":"Drumpad_Drumpad__udoTO","DrumpadKey":"Drumpad_DrumpadKey__bhgsy","DrumpadName":"Drumpad_DrumpadName__ov4Zn","DrumpadActive":"Drumpad_DrumpadActive__31XpG"};